import { motion } from 'framer-motion';
import { createStyles } from '@mantine/core';

import type { SingleSlate } from '../../types/single.slate';

type PickProps = Pick<SingleSlate, 'isLive'> & {
  animationBGColorPickStatus: string;
};

const usePickAnimationStyles = createStyles({
  root: {
    position: 'absolute',
    height: '100%',
    left: 0,
    top: 0,
  },
});

function PickLiveAnimation({ isLive, animationBGColorPickStatus }: PickProps) {
  const { classes } = usePickAnimationStyles();

  const pulseAnimation = {
    animate: {
      scale: [1, 6],
      opacity: [0.7, 0],
      boxShadow: [
        `0 0 0 0 ${animationBGColorPickStatus}`,
        `0 0 0 50px ${animationBGColorPickStatus}`,
      ],
      transition: {
        duration: 2.5,
        repeat: Infinity,
      },
    },
  };

  if (!isLive) return null;

  return (
    <motion.div
      className={classes.root}
      variants={pulseAnimation}
      initial="animate"
      animate="animate"
      data-chromatic="ignore"
    />
  );
}

export default PickLiveAnimation;
